import 'cross-fetch/polyfill' // enable fetch in node environment & browser environment
import { ApolloClient, DefaultOptions, HttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

const authLink = setContext((_, { headers }) => {
  const authToken = process.env.AUTH_TOKEN || 'dev_script_auth_token'

  const headersWithAuth = Object.assign(
    {},
    headers,
    { 'X-CSRF': 'csrf' },
    authToken ? { 'X-AuthToken': authToken } : {}
  )
  return {
    headers: headersWithAuth,
  }
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    )
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`)
  }
})

/**
 * This is the Apollo (graphql) client for our server-side rendered pages.
 * Those include the Transcript, NPS Survey, and Add Agent form. They can be client facing.
 *
 * This Apollo client does not actually give any access to our GraphQL API from the browser.
 * Rather, it lets our own Lambda backend load data from GraphQL to render a page.
 *
 * External users then interact with the page. When they want to make changes (say, submit
 * an NPS survey, or add agents) that happens via plain REST POST, not via a GQL mutation.
 */
export function createRequestScopedClient() {
  const domainName = process.env.DOMAIN_NAME || 'dynasty.com'
  const httpLink = new HttpLink({
    uri: process.env.NODE_ENV === 'production' ? `https://${domainName}/graphql` : 'http://localhost:8888/graphql',
    credentials: 'same-origin',
    fetch: (uri: any, options: any) => {
      const reqBody = JSON.parse(options!.body! as string)
      const opName = reqBody.operationName
      const actionName = reqBody.variables?.action?.actionName
      return fetch(`${uri}?opName=${opName}${actionName ? `&actionName=${actionName}` : ''}`, options)
    },
  })

  const link = authLink.concat(errorLink).concat(httpLink)
  const defaultOptions: DefaultOptions = {
    query: {
      fetchPolicy: 'cache-first',
    },
  }

  const cache = new InMemoryCache()
  return new ApolloClient({ link, cache, defaultOptions })
}
